import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

//base URL for SQL query
let baseURL = "";

if (process.env.REACT_APP_PROJECT_ID === "sail-dev-62f69") {
	//DEV
	baseURL = "https://us-central1-sail-dev-62f69.cloudfunctions.net/app";
} else if (process.env.REACT_APP_PROJECT_ID === "sail-staging-4dcfb") {
	//STAGE
	baseURL = "https://us-central1-sail-staging-4dcfb.cloudfunctions.net/app";
} else if (process.env.REACT_APP_PROJECT_ID === "eco-seeker-310618") {
	//PRODUCTION
	baseURL = "https://us-central1-eco-seeker-310618.cloudfunctions.net/app";
}

// testing emulators URL
if (window.location.hostname === "localhost") {
	baseURL = `http://localhost:5001/${process.env.REACT_APP_PROJECT_ID}/us-central1/app`;
}

const firebaseConfig = {
	apiKey: process.env.REACT_APP_API_KEY,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_PROJECT_ID,
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_APP_ID,
	measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
auth.setPersistence(firebase.auth.Auth.Persistence.SESSION); //each tab has different uid; uid stored in sessionStorage

const firestore = firebase.firestore();
const functions = firebase.functions();

//Use firebase emualator when running React locally.
if (window.location.hostname === "localhost") {
	functions.useEmulator("localhost", 5001);
	firestore.useEmulator("localhost", 8080);
	auth.useEmulator("http://localhost:9099/", { disableWarnings: true });
}

export { firestore, auth, functions, baseURL };

// Get user on load - sign in anonymously for wizard
export const getUserOnLoad = async () => {
	return new Promise(async function (resolve, reject) {
		var user = auth.currentUser;

		if (user) {
			resolve(user);
		} else {
			try {
				const result = await auth.signInAnonymously();
				resolve(result.user);
			} catch (err) {
				reject("error");
			}
		}
	});
};
